import React from "react";

const Praise = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M25.5 23.087V33.26a.733.733 0 0 1-.38.644.758.758 0 0 1-.756-.01L18 30.127l-6.364 3.769a.758.758 0 0 1-1.035-.264.732.732 0 0 1-.101-.373v-10.17a11.835 11.835 0 0 1-4.036-5.983c-.685-2.359-.61-4.87.213-7.184a11.86 11.86 0 0 1 4.384-5.74A12.11 12.11 0 0 1 18 2c2.486 0 4.911.762 6.94 2.181a11.86 11.86 0 0 1 4.383 5.74c.823 2.315.898 4.825.213 7.184a11.835 11.835 0 0 1-4.036 5.983v-.002Zm-7.5-.363a9.061 9.061 0 0 0 6.364-2.602A8.824 8.824 0 0 0 27 13.842a8.824 8.824 0 0 0-2.636-6.281A9.061 9.061 0 0 0 18 4.959a9.061 9.061 0 0 0-6.364 2.602A8.824 8.824 0 0 0 9 13.84c0 2.356.948 4.615 2.636 6.281A9.061 9.061 0 0 0 18 22.724Zm0-2.96a6.04 6.04 0 0 1-4.243-1.735A5.882 5.882 0 0 1 12 13.84c0-1.57.632-3.076 1.757-4.187A6.04 6.04 0 0 1 18 7.92a6.04 6.04 0 0 1 4.243 1.734A5.882 5.882 0 0 1 24 13.842c0 1.57-.632 3.076-1.757 4.187A6.04 6.04 0 0 1 18 19.763Z"
            fill={fill}
        />
    </svg>
);

export default Praise;
